export default "__VITE_ASSET__Ba5Tu2XK__"